import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, HostBinding } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { EmptyObject, WebUtils } from '../common/utils';
import { AccessUtils, TBooking } from '../core/entities';
import { SiteLangMixin } from '../core/lang';
import { SessionService } from '../session.service';
import { SiteFormatMixin } from '../thinkdesks/site.format.mixin';
import { QRCodeWidget } from './qrcode.widget';
import { SpaceCard } from "./space.card";
@Component({
  selector: 'app-booking-invite-exceeded-page',
  standalone: true,
  imports: [CommonModule,
    RouterLink,
    QRCodeWidget, SpaceCard],
  templateUrl: './booking.invite.exceeded.page.html',
})
export class BookingInviteExceededPage extends SiteLangMixin(SiteFormatMixin(EmptyObject)) {
  _common = _common;
  @HostBinding('class') css = 'max-scroll';
  code = '';

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    public override session: SessionService,
    private route: ActivatedRoute,
    private router: Router,

  ) {
    super();



  }
  ngOnInit() {

    this.refresh();
  }
  ngOnDestroy() {

  }

  hash: string;
  object: TBooking;
  refresh() {
    let code = this.route.snapshot.paramMap.get('code');
    if (!code) {
      this.router.navigate([this.session.path('/')]);
      return
    }
    let parts = code.split('-');
    if (parts.length != 2) {
      this.router.navigate([this.session.path('/')]);
      return
    }
    let id = parseInt(parts[0]);
    this.hash = parts[1];
    let url = `/api/client/booking/${id}/invite/${this.hash}`;
    WebUtils.web_result(
      this.http.get(url),
      (result) => {

        this.object = result;
        AccessUtils.fixBooking(this.object);

      },
      null,
      (err) => {
        this.router.navigate([this.session.path('/')]);
      }
    );

  }


}
